import { render, staticRenderFns } from "./MyLitterRegistrationRequest.vue?vue&type=template&id=38756580"
import script from "./MyLitterRegistrationRequest.vue?vue&type=script&lang=ts"
export * from "./MyLitterRegistrationRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports